import { useMemo } from "react";

import { NavGroup, NavItemProps } from "am-tax-fe-core";

import { useApplications, useNavItems, useNavItemsForEngagement } from "../../../api/index.ts";
import { EngagementArea } from "../../../auth/Permissions.ts";
import { useEngagementAppPermissions } from "../../../hooks/usePermissions.ts";
import { NavArea } from "../../../types/enums/index.ts";

import { getNavItem, NavItemExtended } from "./app-utils.tsx";

export interface EngagementAppItems {
    items: Array<NavGroup | NavItemProps>;
    isLoading: boolean;
    enabled?: boolean;
    error?: string | undefined;
}

export const useEngagementAppItems = (engagementId: string, enabled = true): EngagementAppItems => {
    const { data: navItems, isLoading: isNavItemsLoading } = useNavItems();
    const { data: engagementNavItems, isLoading: isEnagementItemsLoading } = useNavItemsForEngagement(engagementId);
    const { data: applications, isLoading: isApplicationsLoading } = useApplications(engagementId);

    const engagementAppPermissions = useEngagementAppPermissions(engagementId, enabled);

    const isLoading = isNavItemsLoading || isEnagementItemsLoading || isApplicationsLoading;

    const engagementItems = useMemo(
        () => [...(navItems ?? []).filter(item => item.area === NavArea.Engagement), ...(engagementNavItems ?? [])],
        [navItems, engagementNavItems],
    );

    const groupList: Array<NavGroup | NavItemProps> = [];

    if (engagementAppPermissions.has(EngagementArea.read)) {
        if (engagementItems && engagementItems.length > 0) {
            const headerGroup: NavGroup = {
                isGroup: true,
                groupColor: "transparent",
                groupMargin: "1rem 0 0 0",
                itemDefaults: { hoverColor: "greenAlpha.400", activeColor: "green.500" },
                groupHeading: "Applications",
                items: [],
            };
            groupList.push(headerGroup);
        }

        if (engagementItems.length) {
            for (const navItem of engagementItems) {
                if (navItem) {
                    const groupItem = getNavItem(navItem as NavItemExtended, engagementId, undefined, applications ?? []);
                    if (groupItem) {
                        groupList.push(groupItem);
                    }
                }
            }
        }
    }

    return { items: groupList, isLoading };
};
